import { render, staticRenderFns } from "./packageGroup.vue?vue&type=template&id=93d981b6&scoped=true"
import script from "./packageGroup.vue?vue&type=script&lang=js"
export * from "./packageGroup.vue?vue&type=script&lang=js"
import style0 from "./packageGroup.vue?vue&type=style&index=0&id=93d981b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d981b6",
  null
  
)

export default component.exports